<template>
    <div class="mb-3">
        <b-table-simple hover responsive>
            <b-thead>
                <b-tr>
                    <b-th>選択</b-th>
                    <b-th></b-th>
                    <b-th>サービス名</b-th>
                    <b-th>所要日数</b-th>
                    <b-th>内訳</b-th>
                    <b-th>合計金額</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-for="(plans, courier) in courier_plans" v-if="courier !== 'model'">
                    <template v-for="(plan_value, key) in plans">
                        <b-tr :variant="isSelected(courier, key, plan_value) ? 'primary' : ''">
                            <b-td>
                                <template v-if="!isSelected(courier, key, plan_value)">
                                    <a href="javascript:void(0)" @click="onSelect(courier, key, plan_value)">選択</a>
                                </template>
                                <template v-else>
                                    <a href="javascript:void(0)" class="text-danger" @click="onSelect(null, null, null)">解除</a>
                                </template>
                            </b-td>
                            <b-td>
                                <b-img :src="`/images/icon_${courier}.png`" height="40"></b-img>
                            </b-td>
                            <b-td>
                                {{ key }}
                                <div v-if="courier === 'ecms'">
                                    <small>
                                        <ul class="pl-4">
                                            <li>指定倉庫への送料は利用者負担＆集荷なし</li>
                                            <li>ご利用には別途契約が必要です。お問い合わせください。<a href="mailto:info@tuskey.one">info@tuskey.one</a></li>
                                        </ul>
                                    </small>
                                </div>
                            </b-td>
                            <b-td class="text-right">
                                {{ plan_value.deliveryCapabilities.totalTransitDays }}
                            </b-td>
                            <b-td>
                                <div class="d-flex" v-for="breakdown in plan_value.detailedPriceBreakdown[0].breakdown.filter((v) => v.price )" :key="breakdown.name">
                                    <div class="flex-grow-1">
                                        {{ breakdown.name }}
                                    </div>
                                    <div class="flex-shrink-1">
                                        &yen;{{ breakdown.price | baseNumberFormatter }}
                                    </div>
                                </div>
                            </b-td>
                            <b-td class="text-right">
                                <template v-if="plan_value.totalPrice[0].price !== null">
                                    &yen;{{ plan_value.totalPrice[0].price | baseNumberFormatter }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </b-td>
                        </b-tr>
                    </template>
                </template>
            </b-tbody>
        </b-table-simple>

<!--
        <p>
            米国輸入時手数料に関しては$1/100円での算出とさせて頂いております
        </p>
        <p>
            【複数個口の請求重量算出方法はこちらをご参照くださいませ】
        </p>
        <p>
            https://www.globalbrand.co.jp/the-way-of-calculation-of-billing-weight/3221/
        </p>
        <p>
            ※システム都合上FEDEX INTERNATIONAL PRIORITYは数十円の誤差が生じる場合がございます。
        </p>
        <p>
            ※上記お見積りには、一時的に発生する料金（緊急事態追加金 や ピークシーズンサーチャージ等）は含まれておりませんのでご留意ください。
        </p>
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import FormModal from '@/components/FormModal.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import InputError from '@/components/InputError.vue'
import blueimpLoadImage from 'blueimp-load-image'

export default {
    components: {
        InputError,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
        error: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
        from: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        to: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        importer: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        boxes: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        items: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        currency: {
            type: String,
            required: true,
            default() {
                return 'JPY'
            },
        },
        shipping_date: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
        plt: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            courier_plans: {
                dhl: {},
                fedex: {},
                ups: {},
                ecms: {},
            },

            selected_old: {
                courier: null,
                plan_name: null,
                plan_value: null,
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
            'filter4address',
            'get_items_total',
            'get_boxes_total',
        ]),
    },
    watch: {
        value: {
            async handler (newValue, oldValue) {
                // aaaa
//                if (this.type === 'date-range') {
//                    let range = this.parseDateRange(newValue)
//                    this.date1 = range.date1
//                    this.date2 = range.date2
//                }
            },
            immediate: true,
        },
        from: {
            handler (newValue, oldValue) {
                if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                    return
                }
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
        to: {
            handler (newValue, oldValue) {
                if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                    return
                }
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
        importer: {
            handler (newValue, oldValue) {
                if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
                    return
                }
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
        boxes: {
            handler (newValue, oldValue) {
                this.setDefaultValue()
//                this.fetchRates()
            },
            deep: true,
        },
        items: {
            handler (newValue, oldValue) {
                this.setDefaultValue()
//                this.fetchRates()
            },
            deep: true,
        },
        currency: {
            handler (newValue, oldValue) {
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
        shipping_date: {
            handler (newValue, oldValue) {
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
        plt: {
            handler (newValue, oldValue) {
                this.setDefaultValue()
//                this.fetchRates()
            },
        },
    },
    mounted() {},
    methods: {
        async fetchRates ($event) {
            this.$utils.set(this.courier_plans, {
                dhl: {},
                fedex: {},
                ups: {},
                ecms: {},
            })

            let items_total = this.get_items_total(this.items)
            let boxes_total = this.get_boxes_total(this.boxes)

//            if (
//                !this.from.from_representative
//                || !this.from.from_line1
//                || !this.from.from_city
//                || !this.from.from_state
//                || !this.from.from_country
//                || !this.to.to_representative
//                || !this.to.to_line1
//                || !this.to.to_city
//                || !this.to.to_state
//                || !this.to.to_country
//                || !this.importer.importer_representative
//                || !this.importer.importer_line1
//                || !this.importer.importer_city
//                || !this.importer.importer_state
//                || !this.importer.importer_country
//
//                || boxes_total.total_weight === 0
//                || boxes_total.total_dimensional_weight === 0
//                || items_total.total_item_count === 0
//                || items_total.total_item_price === 0
//
//                || !this.shipping_date
//            ) {
//                return
//            }

            await this.$store
                .dispatch('shipping/rate', Object.assign(
                    {
                        boxes: this.boxes,
                        items: this.items,
                        currency: this.currency,
                        shipping_date: this.shipping_date,
                        plt: this.plt,
                    },
                    this.from,
                    this.to,
                    this.importer,
                ))
                .then((response) => {
                    this.$utils.set(this, { courier_plans: response.data, })
                })
                .catch((error) => {
                    this.$emit('select', null, null, null)
                })

            // re-select same plan
            let re_select = false
            Object.keys(this.courier_plans).forEach((courier) => {
                if (courier !== this.selected_old.courier) {
                    return
                }
                Object.keys(this.courier_plans[courier]).forEach((plan_name) => {
                    if (plan_name !== this.selected_old.plan_name) {
                        return
                    }

                    const plan_value = this.courier_plans[courier][plan_name]
                    this.onSelect(courier, plan_name, plan_value)
                    re_select = true
                })
            })
            if (!re_select) {
                this.onSelect(null, null, null)
            }
        },
        onSelect (courier, plan_name, plan_value, keep_selected_old = false) {
            this.$nextTick(() => {
                this.$emit('select', courier, plan_name, plan_value)
            })

            if (!keep_selected_old) {
                this.selected_old = this.$utils.copy({
                    courier: courier,
                    plan_name: plan_name,
                    plan_value: plan_value,
                })
            }
        },
        isSelected(courier, plan_name, plan_value) {
            if (this.value.courier !== courier) {
                return false
            }
            if (this.value.plan_name !== plan_name) {
                return false
            }
            if (JSON.stringify(this.value.plan_name) !== JSON.stringify(plan_name)) {
                return false
            }
            return true
        },
        setDefaultValue () {
            this.$utils.set(this.courier_plans, {
                dhl: {},
                fedex: {},
                ups: {},
                ecms: {},
            })
            this.onSelect(null, null, null, true)
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.order-provider {
    max-width: 8em;
}
</style>


